/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Injectable } from '@angular/core';

/**
 * @export
 * @class TerminalConfigService
 */
@Injectable()
export class TerminalConfigService {
  terminalConfigData;

  constructor() {
    this.terminalConfigData = {
      header: {
        spinner: {
          allValues: [
            { label: 12, value: 12 },
            { label: 16, value: 16 },
            { label: 20, value: 20 },
            { label: 24, value: 24 },
            { label: 36, value: 36 },
            { label: 48, value: 48 },
            { label: 60, value: 60 },
            { label: 72, value: 72 },
          ],
          minVal: 12,
          maxVal: 72,
          defaultValue: 24,
          step: 12
        }
      },
      footer: {
        carousel: {
          numVisible: 8
        }
      },
      messages: {
        blankSearchTerminal: 'Search a Terminal to display information.',
        errorSearchTerminal: 'Enter valid Terminal Mnemonic',
        youHave: 'You have',
        pendingWithoutSubmit: 'currently pending. Do you want to leave the Terminal Status window without submitting?',
        duplicateLocosPopupMessage: 'Duplicate Locomotive Selected',
        duplicateLocosPopupTitle: 'Invalid Locomotive Selection',
        duplicateLocosinPendingListPopupMessage: 'Duplicate Locomotive is already in pending list',
        duplicateLocosinPendingListPopupTitle: 'Invalid Locomotive Selection'
      },
      subTypes: {
        handling: {
          inbound: {
            filterLabel: {
              totalLoco: 'Total Loco',
              serviceCenterShop: 'Service Center / Shop',
              mainTrack: 'Main Track',
              truckFuel: 'Truck Fuel',
              toStorage: 'To Storage',
              nextAssignment: 'Next Assignment'
            },
            table: {
              mainHeader: 'INBOUND',
              headerLabel: {
                trainLoco: 'TRAIN / LOCO',
                terminalHandlingPlan: 'TERMINAL HANDLING PLAN',
                changedBy: 'CHANGED BY',
                plannedAssignment: 'NEXT PLANNED ASSIGNMENT',
                projectedDeparture: 'PROJECTED DEPARTURE',
                previousPlan: 'PREVIOUS PLAN'
              }
            }
          },
          onTerminal: {
            filterLabel: {
              totalLoco: 'Total Loco',
              serviceCenterShop: 'Service Center / Shop',
              mainTrack: 'Main Track',
              truckFuel: 'Truck Fuel',
              storage: 'Storage',
              nextAssignment: 'Next Assignment'
            },
            table: {
              mainHeader: 'ON TERMINAL',
              headerLabel: {
                previousAssignmentLoco: 'PREVIOUS ASSIGNMENT / LOCO',
                terminalHandlingPlan: 'TERMINAL HANDLING PLAN',
                changedBy: 'CHANGED BY',
                actualActivity: 'ACTUAL ACTIVITY',
                plannedAssignment: 'NEXT PLANNED ASSIGNMENT',
                projectedDeparture: 'PROJECTED DEPARTURE',
                previousPlan: 'PREVIOUS PLAN'
              }
            }
          }

        },
        status: {

        },
        notes: {

        }

      }
    };
  }
}
